import { Component, ElementRef, HostBinding, HostListener, Input, ViewEncapsulation } from '@angular/core';
import { CwSelectService } from '../select.service';

@Component({
    selector: 'cw-select-option',
    styleUrls: [
        'select-option.component.scss'
    ],
    template: `
        <div class="cw-md-select-option__wrapper">
            <ng-content />
        </div>`,
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class CwSelectOptionComponent {
    @HostBinding('class.state--active')
    public isActive = false;

    @HostBinding('class.cw-md-select-option')
    public readonly HOST_CLASS_FLAG = true;

    private _value: any;

    constructor(
        protected elementRef: ElementRef,
        protected selectService: CwSelectService
    ) {}

    public get label(): string {
        return (this.elementRef.nativeElement.innerText || '').trim();
    }

    @Input()
    public set value(value: any) {
        this._value = value;
    }

    public get value(): string {
        return this._value || this.label;
    }

    @HostListener('click')
    protected onClickOption(): void {
        const selectedOption = {
            value: this.value,
            label: this.label
        };

        this.selectService.selectOptionTopic$.next(selectedOption);
    }
}
